import { styled } from 'css-literal-loader/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import WarrantyModal from './WarrantyModal';

const Button = styled('button', null, "Button", require("./WarrantyInfoLink-Button.module.scss"), "button", "button");

const propTypes = {};

class WarrantyInfoLink extends React.Component {
  state = { show: false };

  handleShow = () => {
    this.setState({ show: true });
  };

  handleHide = () => {
    this.setState({ show: false });
  };

  render() {
    return (
      <>
        <Button type="button" onClick={this.handleShow}>
          <FormattedMessage
            defaultMessage="Warranty Info"
            id="warrantyInfo.button"
          />
        </Button>
        <WarrantyModal show={this.state.show} onHide={this.handleHide} />
      </>
    );
  }
}

WarrantyInfoLink.propTypes = propTypes;

export default WarrantyInfoLink;
